module.exports = __webpack_public_path__ + "img/kbankLogo.06de555b.jpeg";